import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store';
import {
  AjusteMutationAction,
  clearMutationError,
  fetchAjustesAntecipacaoThunk,
  removeAjusteAntecipacaoThunk,
  setCurrentClienteId,
  upsertAjusteAntecipacaoThunk,
} from '../store/slices/ajuste-antecipacao.slice';
import {
  MoedaAjuste,
  UpsertAjusteAntecipacaoPayload,
} from '../types/ajuste-antecipacao';

export const useAjusteAntecipacao = (clienteId: string | undefined) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.ajusteAntecipacao);

  useEffect(() => {
    dispatch(setCurrentClienteId(clienteId ?? null));
  }, [dispatch, clienteId]);

  const refresh = useCallback(() => {
    if (!clienteId) return Promise.resolve(undefined);
    return dispatch(fetchAjustesAntecipacaoThunk(clienteId));
  }, [dispatch, clienteId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    items: state.items,
    status: state.status,
    error: state.error,
    mutating: state.mutating,
    mutationError: state.mutationError,
    refresh,
    upsert: (moeda: MoedaAjuste, payload: UpsertAjusteAntecipacaoPayload) => {
      if (!clienteId) return Promise.resolve(undefined);
      return dispatch(
        upsertAjusteAntecipacaoThunk({ clienteId, moeda, payload }),
      );
    },
    remove: (moeda: MoedaAjuste) => {
      if (!clienteId) return Promise.resolve(undefined);
      return dispatch(removeAjusteAntecipacaoThunk({ clienteId, moeda }));
    },
    isMutating: (moeda: MoedaAjuste, action: AjusteMutationAction) =>
      state.mutating?.moeda === moeda && state.mutating?.action === action,
    clearMutationError: () => dispatch(clearMutationError()),
  };
};
